import { Flex, Image, Text, TextSize } from 'components'
import styled from 'styled-components'
import { GLOBAL_COLORS } from 'theme'

export const Wrapper = styled.div`
  width: 280px;
  height: 317px;
  display: flex;
  flex-direction: column;
  box-shadow: 0px 2px 30px 0px rgba(0, 0, 0, 0.15);
  margin-top: 40px;
  border-radius: 20px;
  padding: 20px;
  box-sizing: border-box;
  background: ${({ theme }) => theme.darkMode && GLOBAL_COLORS.switchGrey};
`

export const TooltipWrapper = styled.div`
  display: flex;
  flex-direction: column;
  ${({ theme }) => theme.mediaWidth.Mobile`
  align-items: center;
`}
`

export const RebalanceTooltipBody = styled.div`
  display: flex;
  align-items: center;
  border: 1px solid #e34242;
  border-radius: 10px;
  margin-top: 10px;
  padding: 5px;
  height: 50px;
  width: 100%;
  max-width: 280px;
  background: #e342424d;
  box-sizing: border-box;
`

export const RebalanceTooltipContent = styled(Flex)`
  gap: 10px;
`

export const StyledRebalancingText = styled(Text)`
  font-size: ${TextSize.small};
  align-self: center;
`

// COOKIE index styles
export const ProductIcon = styled(Image)`
  background-size: cover;
  height: 56px;
  width: 56px;
  border-radius: 50%;
`
export const CoverIconsWrapper = styled(Flex)`
  gap: 10px;
`

export const CoverWrapper = styled(Flex)`
  flex-direction: column;
  gap: 20px;
  align-items: center;
  justify-content: center;
  height: 80%;
  text-align: center;
`
